export default "__VITE_ASSET__mo08bQVD__"